import React from 'react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Calendar } from '@/components/ui/calendar';
import { CalendarIcon } from 'lucide-react';
import { format, subDays } from 'date-fns';
import { cn } from '@/lib/utils';

interface Props {
  startDate: Date;
  endDate: Date;
  onChangeRange: (start: Date, end: Date) => void;
}

const presets = [
  { label: '7d', days: 7 },
  { label: '30d', days: 30 },
  { label: '90d', days: 90 },
];

export const DateRangeFilter = ({ startDate, endDate, onChangeRange }: Props) => {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      {presets.map(p => (
        <Button
          key={p.label}
          size="sm"
          variant="outline"
          className={cn(
            'h-8 text-xs',
            Math.round((endDate.getTime() - startDate.getTime()) / 86400000) === p.days &&
              'bg-primary text-primary-foreground hover:bg-primary/90'
          )}
          onClick={() => onChangeRange(subDays(new Date(), p.days), new Date())}
        >
          {p.label}
        </Button>
      ))}
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="outline" size="sm" className="h-8 text-xs gap-1">
            <CalendarIcon className="h-3 w-3" />
            {format(startDate, 'MMM dd')} – {format(endDate, 'MMM dd')}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="range"
            selected={{ from: startDate, to: endDate }}
            onSelect={(range) => {
              if (range?.from && range?.to) {
                onChangeRange(range.from, range.to);
              } else if (range?.from) {
                onChangeRange(range.from, range.from);
              }
            }}
            numberOfMonths={2}
            className={cn("p-3 pointer-events-auto")}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};
